<script>
  // core components
  import AtributoView from "../../viewsERP/Atributo.svelte";
  
  // Handle router props
  export let location;
  export let id;
</script>

<div class="flex flex-wrap mt-4">
  <div class="w-full mb-12 px-4">
    <AtributoView />
  </div>
</div>